import { Button, Modal } from "antd";
import React from "react";
import { FormWrapperSC } from "./styled";

interface ConfirmModalProps {
  onOk?: (e?: React.SyntheticEvent) => void;
  onCancel: (e?: React.SyntheticEvent) => void;
  open: boolean;
  title: string;
  text?: string;
  body?: React.ReactNode;
}

export const DefaultModal: React.FC<ConfirmModalProps> = ({
  text,
  onOk,
  onCancel,
  open,
  body,
  title,
}) => {
  const footer = [];
  if (onOk) {
    const handleOk = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onOk();
    };

    footer.push(
      <Button key="submit" type="primary" onClick={handleOk}>
        OK
      </Button>,
    );
  }

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onCancel();
  };

  return (
    <Modal open={open} title={title} onCancel={handleCancel} footer={footer}>
      <FormWrapperSC>
        {text}
        {body}
      </FormWrapperSC>
    </Modal>
  );
};
